import port_30 from "../../assets/hive-dashboard/greet-cards/30 inex_01.png";
import port_30_2 from "../../assets/hive-dashboard/greet-cards/30inex_02.png";
import land_30 from "../../assets/hive-dashboard/greet-cards/30inex_03.png";
import land_30_2 from "../../assets/hive-dashboard/greet-cards/30inex_04.png";

import port_50 from "../../assets/hive-dashboard/greet-cards/50 inex_01.png";
import port_50_2 from "../../assets/hive-dashboard/greet-cards/50 inex_02.png";
import land_50 from "../../assets/hive-dashboard/greet-cards/50 inex_03.png";
import land_50_2 from "../../assets/hive-dashboard/greet-cards/50 inex_04.png";

export const GreetData = [
    {
        id: "1",
        type:'30-inex',
        orient:'portrait',
        photo: port_30,
        imageUrl: "https://indexx-exchange-2.s3.ap-northeast-1.amazonaws.com/30+INEX/30+2+new.png"
    },
    {
        id: "2",
        type:'30-inex',
        orient:'portrait',
        photo: port_30_2,
        imageUrl: "https://indexx-exchange-2.s3.ap-northeast-1.amazonaws.com/30+INEX/30+1+new.png"
    },
    {
        id: "3",
        type:'30-inex',
        orient:'landscape',
        photo: land_30,
        imageUrl: "https://indexx-exchange-2.s3.ap-northeast-1.amazonaws.com/30+INEX/gc+30+4+copy.png"
    },
    {
        id: "4",
        type:'30-inex',
        orient:'landscape',
        photo: land_30_2,
        imageUrl: "https://indexx-exchange-2.s3.ap-northeast-1.amazonaws.com/30+INEX/gc+30+6.png"
    },
    {
        id: "5",
        type:'50-inex',
        orient:'portrait',
        photo: port_50,
        imageUrl: "https://indexx-exchange-2.s3.ap-northeast-1.amazonaws.com/50+INEX/50+1+new.png"
    },
    {
        id: "6",
        type:'50-inex',
        orient:'portrait',
        photo: port_50_2,
        imageUrl: "https://indexx-exchange-2.s3.ap-northeast-1.amazonaws.com/50+INEX/50+2+new.png"
    },
    {
        id: "7",
        type:'50-inex',
        orient:'landscape',
        photo: land_50,
        imageUrl: "https://indexx-exchange-2.s3.ap-northeast-1.amazonaws.com/50+INEX/5022.png"
    },
    {
        id: "8",
        type:'50-inex',
        orient:'landscape',
        photo: land_50_2,
        imageUrl: "https://indexx-exchange-2.s3.ap-northeast-1.amazonaws.com/50+INEX/h1+new.png"
    },
]